import { Button, Checkbox, Form, Input, Message, Tabs } from '@arco-design/web-react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { agentLogin, getAgentList } from '@/services/login'
import AgentStore from '@/stores/agentLogin';
import agentUser from '@/stores/agentUser';
import AccountSelector from '@/components/AccountSelector/AccountSelector';
import { AccountManager, AccountType } from '@/utils/accountManager';
function AgentLogin() {
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [agentLoading, setAgentLoading] = useState(false)
    const [checkdata, setcheckdata] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState('')
    const [rememberedPassword, setRememberedPassword] = useState('');

    const validatePhoneNumber = (value, callback) => {
        const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (!value) {
            callback(<div>请输入正确的用户名</div>);
        } else {
            callback();
        }
    };
    function validatePassword(value, callback) {
        if (!value) {
            callback(<div>密码不能为空</div>);
        } else if (!/^.{6,}$/.test(value)) {
            callback(
                <div>请输入6-12个字符，支持数字、大小写字母和符号至少包含一种</div>
            );
        } else {
            callback();
        }
    }

    const handleAccountChange = (phoneNumber: string, password?: string) => {
        setSelectedAccount(phoneNumber)
        if (password) {
            form.setFieldValue("password", password)
            setRememberedPassword(password)
        } else {
            form.setFieldValue("password", "")
            setRememberedPassword("")
        }
        form.setFieldValue("phone_number", phoneNumber)
    }

    useEffect(() => {
        form.setFieldValue("password", "")
        setRememberedPassword("")
        setSelectedAccount("")
        setcheckdata(false)
        AccountManager.migrateOldAccounts()
    }, []);
    const onSubmit = (type) => {
        form.validate().then(formData => {
            if (loading || agentLoading) return
            if (type === 1) {
                setLoading(true)
            } else {
                setAgentLoading(true)
            }
            agentLogin(formData).then(res => {
                if (res.code != 0) {
                    Message.error(res.message)
                    return
                }
                if (type === 1) {
                    AgentStore.setLoginInfo(res.data)
                    agentUser.setIsThisAgent(false)
                } else {
                    AgentStore.setLoginInfo(res.data)
                    localStorage.setItem('agent_token', res.data.token)
                    localStorage.setItem('Token', res.data.token)
                    sessionStorage.setItem("Token", res.data.token)
                    window.localStorage.setItem("isClient", "true")
                    agentUser.setIsThisAgent(true)
                    getAgentList({
                        type: 1,
                        page: 1,
                        page_size: 1,
                    }).then(res => {
                        const id = res.data?.items?.[0]?.id
                        if (id) {
                            navigate('/matrix')
                            agentUser.setActiveTeamId(id)
                        }
                    }).finally(() => {
                        setAgentLoading(false)
                    })
                }
                if (checkdata) {
                    AccountManager.saveAccount({
                        phone_number: formData.phone_number,
                        password: formData.password,
                        remember_password: checkdata
                    }, AccountType.AGENT)
                }
            }).catch(e => {
                Message.error(e)
            }).finally(() => {
                setLoading(false)
                setAgentLoading(false)
            })
        })
    }
    return (
        <Form form={form} wrapperCol={{ span: 24 }} style={{ width: 386 }}>
            <Form.Item
                field="phone_number"
                rules={[
                    { validator: validatePhoneNumber, validateTrigger: "onBlur" },
                ]}>
                <AccountSelector
                    value={selectedAccount}
                    onChange={handleAccountChange}
                    placeholder="请输入或选择账号"
                    style={{ width: '100%' }}
                    accountType={AccountType.AGENT}
                />
            </Form.Item>
            <Form.Item field="password"
                rules={[{ validator: validatePassword, validateTrigger: ["onBlur"] }]}
            >
                <Input.Password className="login-input" placeholder='请输入密码'></Input.Password>
            </Form.Item>
            <div id="login-actions">
                <Checkbox
                    checked={checkdata}
                    onChange={() => {
                        setcheckdata(!checkdata);
                    }}
                >
                    记住密码
                </Checkbox>

            </div>
            <Form.Item>
                <Button loading={loading} className="login-button" type="primary" size="large" onClick={() => onSubmit(1)}>登录</Button>
                <Button loading={agentLoading} className="login-button" style={{ marginTop: '16px' }} type="outline" size="large" onClick={() => onSubmit(2)}>登录此账号</Button>
            </Form.Item>
        </Form>
    )
}

export default AgentLogin